import reqInfo from './index';
import { isArray, reportEvent } from '../util/util';

const UpdateData = (key, keys, curInterfaceInfo) => {
  if (curInterfaceInfo.code === 0) {
    const allInterfaceDataCache = JSON.parse(localStorage.getItem('allInterfaceDataCache-kernel')) || {};
    allInterfaceDataCache[key] = allInterfaceDataCache[key] || [];
    const curCacheDataIdx = findDataIndex(allInterfaceDataCache[key], keys);
    keys.forEach(({ key, value }) => {
      // eslint-disable-next-line
      curInterfaceInfo[key] = value;
    });
    if (curCacheDataIdx !== -1) {
      allInterfaceDataCache[key][curCacheDataIdx] = curInterfaceInfo;
    } else {
      allInterfaceDataCache[key].push(curInterfaceInfo);
    }
    if (allInterfaceDataCache[key].length > 10) {
      // 保存十个请求，多的去除掉
      allInterfaceDataCache[key] = allInterfaceDataCache[key].slice(-10);
    }
    localStorage.setItem('allInterfaceDataCache-kernel', JSON.stringify(allInterfaceDataCache));
  }
};

const rumReport = ({
  eventName,
  isFirstEnter,
}) => {
  if (isFirstEnter) {
    reportEvent({
      name: eventName, // 埋点名称
    });
  }
};

const findDataIndex = (curReqCacheData, keys) => (
  curReqCacheData.findIndex((data) => {
    let isThisData = true;
    for (let index = 0; index < keys.length; index++) {
      const keyObj = keys[index];
      if (keyObj.key === 'pageCtx' && keyObj.value && data[keyObj.key]) {
        // 这个地方不太清楚，主页获取数据，同样的位置获取数据时pageCtx部分不一致，导致内容多次写入，这里区分下
        // keyObj为空字符串时是第一页，也使用下方的方法，不为空时，才能通过homeCtxReg匹配到
        const resultParmas = decodeURIComponent(keyObj.value).match(homeCtxReg);
        const resultNow = decodeURIComponent(data[keyObj.key]).match(homeCtxReg);
        if (resultParmas && resultNow) {
          if (resultParmas[0] !== resultNow[0]) {
            isThisData = false;
            break;
          }
        }
      } else {
        if (data[keyObj.key] !== keyObj.value) {
          isThisData = false;
          break;
        }
      }
    }
    return isThisData;
  })
);

const homeCtxReg = /chid=.+mod=\d+-\d+/;

export const getDataProcy = ({
  key,
  // secondKey, // 同一个接口，不一样参数，用这个区分
  keys,
  body,
  params,
  // isNeedSecondKey, // 被告知是否要区分
  isFirstEnter, // 是否是第一次进入应用，主页第一屏数据获取
}) => {
  rumReport({
    eventName: 'homePage_first_getData',
    isFirstEnter,
  });
  return new Promise(async (resolve) => {
    const allInterfaceDataCache = JSON.parse(localStorage.getItem('allInterfaceDataCache-kernel')) || {};
    let curReqCacheData = allInterfaceDataCache[key] || [];
    // 之前的代码有问题，这里兜底之前的代码，之前代码该数据格式为对象
    if (!isArray(curReqCacheData)) {
      localStorage.removeItem('allInterfaceDataCache-kernel');
      curReqCacheData = [];
    }
    const curCacheDataIdx = findDataIndex(curReqCacheData, keys);

    if (curCacheDataIdx !== -1) {
      rumReport({
        eventName: 'homePage_first_getData_useTheCache',
        isFirstEnter,
      });
      resolve(curReqCacheData[curCacheDataIdx]);
      const cacheTimer = setTimeout(async () => {
        const curInterfaceInfo = await reqInfo[key](body, params);
        UpdateData(key, keys, curInterfaceInfo, curCacheDataIdx);
        clearTimeout(cacheTimer);
      }, 0);
    } else {
      rumReport({
        eventName: 'homePage_first_getData_notUseTheCache',
        isFirstEnter,
      });
      const curInterfaceInfo = await reqInfo[key](body, params);
      const cacheTimer = setTimeout(() => {
        UpdateData(key, keys, curInterfaceInfo);
        clearTimeout(cacheTimer);
      }, 0);
      resolve(curInterfaceInfo);
    }
  });
};
